import { List, ListItem } from 'foundations-components/transitional/components/List';
import I18n from 'I18n';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { GithubIcon } from 'foundations-assets/icons/components/GithubIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { SocialBlockLinkedinIcon } from 'foundations-assets/icons/components/SocialBlockLinkedinIcon';
import { SocialBlockXIcon } from 'foundations-assets/icons/components/SocialBlockXIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SocialLinks = ({
  userProfile,
  isUngatedForUnifiedAcademyNavigation
}) => {
  const {
    linkedinId,
    twitterId,
    githubId,
    meetingsId
  } = userProfile;
  return /*#__PURE__*/_jsxs(List, {
    inline: true,
    children: [linkedinId && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": I18n.text('profilePage.AcademyProfile.header.socialIconAlts.linkedIn'),
        href: `https://www.linkedin.com/in/${linkedinId}`,
        tooltip: I18n.text('profilePage.AcademyProfile.header.socialIconAlts.linkedIn'),
        use: "link",
        children: /*#__PURE__*/_jsx(SocialBlockLinkedinIcon, {
          color: isUngatedForUnifiedAcademyNavigation ? undefined : 'icon-core-on-fill-default',
          size: "300"
        })
      })
    }), twitterId && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": I18n.text('profilePage.AcademyProfile.header.socialIconAlts.twitter'),
        href: `https://www.x.com/${twitterId}`,
        tooltip: I18n.text('profilePage.AcademyProfile.header.socialIconAlts.twitter'),
        use: "link",
        children: /*#__PURE__*/_jsx(SocialBlockXIcon, {
          color: isUngatedForUnifiedAcademyNavigation ? undefined : 'icon-core-on-fill-default',
          size: "300"
        })
      })
    }), githubId && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": I18n.text('profilePage.AcademyProfile.header.socialIconAlts.github'),
        href: `https://github.com/${githubId}`,
        tooltip: I18n.text('profilePage.AcademyProfile.header.socialIconAlts.github'),
        use: "link",
        children: /*#__PURE__*/_jsx(GithubIcon, {
          color: isUngatedForUnifiedAcademyNavigation ? undefined : 'icon-core-on-fill-default',
          size: "300"
        })
      })
    }), meetingsId && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": I18n.text('profilePage.AcademyProfile.header.socialIconAlts.meetings'),
        href: `https://meetings.hubspot.com/${meetingsId}`,
        tooltip: I18n.text('profilePage.AcademyProfile.header.socialIconAlts.meetings'),
        use: "link",
        children: /*#__PURE__*/_jsx(MeetingsIcon, {
          color: isUngatedForUnifiedAcademyNavigation ? undefined : 'icon-core-on-fill-default',
          size: "300"
        })
      })
    })]
  });
};